import { toSelect } from '../../constants';
import { DocumentType } from './types';

export const COLOMBIA_BANK_ACCOUNT_TYPES = {
  savings: { value: 'savings', label: 'employee colombiaBankAccount.savings' },
  checking: {
    value: 'checking',
    label: 'employee colombiaBankAccount.checking'
  }
};

export const documentTypes = [
  { value: DocumentType.PASSPORT, label: 'passport' },
  { value: DocumentType.C_CIUDADANIA, label: 'cc' },
  { value: DocumentType.C_EXTRANJERIA, label: 'ce' },
  { value: DocumentType.PEP, label: 'pep' },
  { value: DocumentType.NIT, label: 'nit' }
];

export const colombiaOptions = (bankEntities: Array<Record<string, string>>) => {
  return {
    documentType: {
      name: 'documentType',
      label: 'document type',
      select: true,
      options: documentTypes,
      md: 3
    },
    personalIdTypeInputOptions: {
      name: 'personalId',
      label: 'document number',
      md: 3
    },
    colombiaBankAccountTypeInputOptions: {
      name: 'bankAccountType',
      label: 'bank account type',
      select: true,
      options: Object.values(COLOMBIA_BANK_ACCOUNT_TYPES),
      md: 6
    },
    bicSwiftInputOptions: {
      name: 'bic_swift',
      label: 'bic swift',
      select: true,
      options: Object.values(toSelect(bankEntities, 'Banco')),
      md: 6
    },
    addressInputOptions: {
      name: 'address',
      label: 'address',
      md: 12
    },
    exclude: 'iban'
  };
};

export const colombiaArrangedOptions = [
  'firstName',
  'lastName',
  'documentType',
  'personalId',
  'bankAccountNumber',
  'email',
  'phone',
  'payrollId',
  'salaryType',
  'startDate',
  'contractEnd',
  'salary',
  'employeeStatus',
  'subsidiary',
  'collectiveIds',
  'status',
  'address',
  'bankAccountType',
  'bic_swift'
];
